import React, { Component } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';

class Profile extends Component {
  render() {
    return (
      <div className="page-profile">

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col className="text-center text-md-left">
              <h3 className="mb-0">Profile Settings</h3>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

              <Card>
                <CardHeader>Personal Information</CardHeader>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label for="firstName">First Name</Label>
                      <Input type="text" name="first-name" id="firstName" defaultValue="Kyle" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="lastName">Last Name</Label>
                      <Input type="text" name="last-name" id="lastName" defaultValue="McConnell" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="Title">Title</Label>
                      <Input type="text" name="title" id="Title" defaultValue="CEO" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="Email">Email Address</Label>
                      <Input type="text" name="email" id="Email" defaultValue="kyle@business.com" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="Phone">Phone Number</Label>
                      <Input type="text" name="phone" id="Phone" defaultValue="(123) 456-7890" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="Extension">Extension</Label>
                      <Input type="text" name="extension" id="Extension" defaultValue="222" />
                    </FormGroup>
                    <Button color="primary" className="w-100 mt-1" disabled>Save</Button>
                  </Form>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>Change Password</CardHeader>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label for="newPassword">New Password</Label>
                      <Input type="password" name="new-password" id="newPassword" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="confirmPassword">Confirm Password</Label>
                      <Input type="password" name="confirm-password" id="confirmPassword" />
                    </FormGroup>
                    <Button color="primary" className="w-100 mt-1" disabled>Save</Button>
                  </Form>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>
              <Card>
                <CardHeader>Business Location</CardHeader>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label for="Address">Address</Label>
                      <Input type="text" name="address" id="Address" defaultValue="1020 W Lawrence Ave" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="Address2">Address 2</Label>
                      <Input type="text" name="address2" id="Address2" placeholder="Apartment, studio, or floor" defaultValue="Apt #508" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="City">City</Label>
                      <Input type="text" name="city" id="City" defaultValue="Chicago" />
                    </FormGroup>
                    <Row form>
                      <Col md={8}>
                        <FormGroup>
                          <Label for="State">State</Label>
                          <Input type="text" name="state" id="State" defaultValue="Illinois" />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="Zip">Zip</Label>
                          <Input type="text" name="zip" id="Zip" defaultValue="60640" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup className="mb-2" check>
                      <Input type="checkbox" name="check" id="Check"/>
                      <Label for="Check" check>This is the primary account address</Label>
                    </FormGroup>
                    <Button color="primary" className="w-100 mt-1" disabled>Save</Button>
                  </Form>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card>
                <CardHeader>Bank Account Information</CardHeader>
                <CardBody>
                  <p>If you need to make any changes to your bank information, please contact us.</p>
                  <Form>
                    <FormGroup>
                      <Label for="accountHolder">Account Holder Name</Label>
                      <Input type="text" name="account-holder" id="accountHolder" value="Kyle McConnell" disabled />
                    </FormGroup>
                    <FormGroup>
                      <Label for="bankName">Bank Name</Label>
                      <Input type="text" name="bank-name" id="bankName" value="Silicon Valley Bank" disabled />
                    </FormGroup>
                    <FormGroup>
                      <Label for="accountType">Account Type</Label>
                      <Input type="text" name="account-type" id="accountType" value="Checking" disabled />
                    </FormGroup>
                    <FormGroup>
                      <Label for="routingNumber">Bank Routing Number</Label>
                      <Input type="text" name="routing-number" id="routingNumber" value="048372644" disabled />
                    </FormGroup>
                    <FormGroup>
                      <Label for="accountNumber">Bank Account Number</Label>
                      <Input type="text" name="account-number" id="accountNumber" value="XXXXX1234" disabled />
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>

            </Col>
          </Row>

        </Container>

      </div>
    );
  }
}

export default Profile;
